export const individualAccountPageTabs = [
  {
    index: 0,
    value: 'activity',
    label: 'Timeline',
  },
  {
    index: 1,
    value: 'details',
    label: 'Details',
  },
  {
    index: 2,
    value: 'relationships',
    label: 'Contacts',
  },
  {
    index: 3,
    value: 'tasks',
    label: 'Tasks',
  },
  {
    index: 4,
    value: 'messages',
    label: 'Messages',
  },
  {
    index: 5,
    value: 'notes',
    label: 'Notes',
  },
  {
    index: 6,
    value: 'files',
    label: 'Files',
  },
  {
    index: 7,
    value: 'emails',
    label: 'Emails',
  },
];

export const accountPageTabs = [
  {
    index: 0,
    value: 'activity',
    label: 'Timeline',
  },
  {
    index: 1,
    value: 'details',
    label: 'Details',
  },
  {
    index: 2,
    value: 'relationships',
    label: 'Contacts',
  },
  {
    index: 3,
    value: 'tasks',
    label: 'Tasks',
  },
  {
    index: 4,
    value: 'messages',
    label: 'Messages',
  },
  {
    index: 5,
    value: 'notes',
    label: 'Notes',
  },
  {
    index: 6,
    value: 'files',
    label: 'Files',
  },
  {
    index: 7,
    value: 'emails',
    label: 'Emails',
  },
];

export const clientAccountPageTabs = [
  {
    index: 0,
    value: 'details',
    label: 'Details',
  },
  {
    index: 1,
    value: 'relationships',
    label: 'Contacts',
  },

  {
    index: 2,
    value: 'files',
    label: 'Files',
  },
];

export const clientIndividualAccountPageTabs = [
  {
    index: 0,
    value: 'details',
    label: 'Details',
  },
  {
    index: 1,
    value: 'relationships',
    label: 'Contacts',
  },
  {
    index: 2,
    value: 'files',
    label: 'Files',
  },
];

export const liteAccountTabs = [
  {
    index: 0,
    value: 'details',
    label: 'Details',
  },
  {
    index: 1,
    value: 'relationships',
    label: 'Contacts',
  },
  {
    index: 2,
    value: 'messages',
    label: 'Messages',
  },
  {
    index: 3,
    value: 'files',
    label: 'Files',
  },
];

export const liteClientAccountTabs = [
  {
    index: 0,
    value: 'details',
    label: 'Details',
  },
  {
    index: 1,
    value: 'relationships',
    label: 'Contacts',
  },
  {
    index: 2,
    value: 'files',
    label: 'Files',
  },
];
